<template>
    <div class="p-3 h-100 animated fadeIn">
        <b-card v-if="pgmAdDto != null">
            <div slot="header">
                <strong>대세 게임 등록</strong>
            </div>
            <b-form @submit="submitHandler">
                <GapPgmAdInputFormat :config="config" :selectedApp="selectedApp" :pgmAdDto="pgmAdDto"></GapPgmAdInputFormat>

                <b-form-group
                        :label="'대표 이미지/영상 설정 ('+lang+')'"
                        :label-class="labelClasses"
                        v-for="lang in languages" :key="lang+'selected'">
                    <ImageVideoSelector :config="config"
                                        :pgmAdDto="pgmAdDto"
                                        :maxSize="0.3"
                                        :lang="lang"
                                        :width="1436"
                                        :height="1412"
                                        :imgThumbnailTrigger="imgThumbnailTrigger"
                                        :dropzoneOptions="dropzoneOptions"></ImageVideoSelector>
                </b-form-group>

                <b-form-group
                        label="노출설정"
                        :label-class="labelClasses">
                    <b-form-radio-group v-model="pgmAdDto.osType" :options="osOptionsForBootstrap">
                    </b-form-radio-group>
                    <p>* 프로모션 스펙에 따라 노출을 원하는 OS를 선택해주세요.</p>
                </b-form-group>

                <b-button type="submit" variant="outline-primary">등록</b-button>
                <b-button typee="button" variant="outline-secondary" v-on:click="$router.go(-1)">뒤로</b-button>
            </b-form>
        </b-card>
    </div>
</template>

<script>
    import GapPgmAdInputFormat from '@/views/PlayGame/components/GapPgmAdInputFormat.vue'
    import ImageVideoSelector from '@/views/PlayGame/components/ImageVideoSelector.vue'

    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { MODULE_NAME as PREG_MODULE, FETCH_PREGS_BY_APP_MASTER_ID, FETCH_CODES } from '@/store/preg/actions.type'
    import { MODULE_NAME as APP_MODULE, FETCH_APPS } from '@/store/app/actions.type'
    import { labelClasses, IMAGE_UPLOAD_URL, DISPLAY_STATE } from '@/constants'
    import { mapState, mapMutations, mapGetters } from 'vuex'
    import { $showModalWithErrorMsg, addProperty, removeProperty, $imgSuccessHandling, $imgRemove, renameAndSetDtoProperty, noDropAndDropOver, $getLinkedSvcType, acceptHandlingForDimensionLimit, thumbhnailHandlingForLimtDismension, validationURL } from '@/common/util'
    import { SHOW_MODAL } from '@/store/ui/mutations.type'
    import playGameService from '@/common/api/playGame.service'

    export default {
        name: "GapMainstreamInput",
        components: {
            ImageVideoSelector,
            GapPgmAdInputFormat,
            vueDropzone: vue2Dropzone
        },
        data () {
            return {
                config : {
                    type : 'playGameMainstream',
                    header : '확장배너',
                    imageTitle : '이미지 업로드'
                },
                imgThumbnailTrigger: false,
                selectedApp: {},
                pgmAdDto: {
                    title: '',
                    appMasterId: 0,
                    appName: '',
                    contentType : '',
                    linkedSvcType: 'preregistration',
                    pregMasterId: 0,
                    linkedUrl: '',
                    contentUrl: {},
                    osType: 'all',
                    downloadStartTime: null,
                    downloadEndTime: null,
                    startTime: null,
                    endTime: null,
                    modUser: null,
                    orderNo: 1,
                    viewTitle : {},
                    viewInfo : {
                        contentType : '',
                        contentUrl : {},
                        viewTitle: {},
                        bgColor: '',
                        downloadStartTime: null,
                        downloadEndTime: null
                    },
                    linkedSvcInfo: {
                        linkedUrl: '',
                        pregMasterId: 0
                    },
                    displayYn: DISPLAY_STATE.ON,
                    bgColor: '#000000'
                },
                languages: ['ko'],
                // dropzoneJs 옵션
                dropzoneOptions: {
                    withCredentials: true,
                    paramName: 'image',
                    url: process.env.VUE_APP_BASE_URL + IMAGE_UPLOAD_URL,
                    dictDefaultMessage: '파일을 선택해주세요.',
                    dictRemoveFile: '삭제',
                    thumbnailWidth: 450,
                    thumbnailHeight: 300,
                    thumbnailMethod: 'contain',
                    addRemoveLinks: true,
                    dictFileTooBig: '파일 용량을 초과하였습니다. (최대 용량 : {{maxFilesize}}MB)',
                    dictMaxFilesExceeded: '{{maxFiles}}개까지 업로드 가능합니다.',
                    dictResponseError: '일시적으로 네트워크 오류가 있습니다. 삭제 후, 다시 시도해주세요.',
                    acceptedFiles: 'image/jpg, image/png, image/jpeg'
                },
                labelClasses: labelClasses,
            }
        },
        created () {
            noDropAndDropOver()
        },
        mounted () {
            this.$store.dispatch(PREG_MODULE + FETCH_CODES)
                .catch($showModalWithErrorMsg.bind(this))

            if (this.$route.params.pgmAdId != null) {
                playGameService.getBanner(this.$route.params.pgmAdId)
                    .then((response) => {
                        console.log('response')
                        console.log(response)

                        this.pgmAdDto = this.makePostPgmAdDto(response.data)

                        this.pgmAdDto.startTime = new Date(this.pgmAdDto.startTime)
                        this.pgmAdDto.endTime = new Date(this.pgmAdDto.endTime)

                        if (this.pgmAdDto.pregMasterId && this.pgmAdDto.title) {
                            let name =  this.pgmAdDto.appName + ' :: ' + this.pgmAdDto.title
                            this.selectedApp = {
                                name: name, value: this.pgmAdDto.pregMasterId
                            }
                        }

                        this.imgThumbnailTrigger = !this.imgThumbnailTrigger
                    })
            }


        },
        methods: {
            makePostPgmAdDto(pgmAdDto) {
                pgmAdDto.contentType = pgmAdDto.viewInfo.contentType
                pgmAdDto.contentUrl = pgmAdDto.viewInfo.contentUrl
                pgmAdDto.viewTitle = pgmAdDto.viewInfo.viewTitle
                pgmAdDto.bgColor = pgmAdDto.viewInfo.bgColor
                pgmAdDto.downloadStartTime = pgmAdDto.viewInfo.downloadStartTime
                pgmAdDto.downloadEndTime = pgmAdDto.viewInfo.downloadEndTime

                pgmAdDto.linkedUrl = pgmAdDto.linkedSvcInfo.linkedUrl
                pgmAdDto.pregMasterId = pgmAdDto.linkedSvcInfo.pregMasterId

                return pgmAdDto
            },
            makePutPgmAdDto(pgmAdDto) {
                pgmAdDto.viewInfo = {}
                pgmAdDto.viewInfo.contentType = pgmAdDto.contentType
                pgmAdDto.viewInfo.contentUrl = pgmAdDto.contentUrl
                pgmAdDto.viewInfo.viewTitle = pgmAdDto.viewTitle
                pgmAdDto.viewInfo.bgColor = pgmAdDto.bgColor
                pgmAdDto.viewInfo.downloadStartTime = pgmAdDto.downloadStartTime
                pgmAdDto.viewInfo.downloadEndTime = pgmAdDto.downloadEndTime

                pgmAdDto.linkedSvcInfo = {}
                pgmAdDto.linkedSvcInfo.linkedUrl = pgmAdDto.linkedUrl
                pgmAdDto.linkedSvcInfo.pregMasterId = pgmAdDto.pregMasterId

                return pgmAdDto
            },
            submitHandler (event) {
                event.preventDefault()
                this.pgmAdDto.modTime = new Date()

                console.log('Mainstream submitHandler')
                console.log(this.pgmAdDto)
                if (!this.pgmAdDto.appName) {
                    console.log(this.pgmAdDto.appMasterId)
                    console.log(this.pgmAdDto.appName)
                    alert("게임과 타입을 선택해주세요.")
                    this.$refs.selectApp.$refs.search.focus()
                    return
                }

                // 일단은 하드코딩..
                // 대표 이미지 한국만 체크한다.
                if (this.pgmAdDto.contentUrl.ko === undefined || this.pgmAdDto.contentUrl.ko === null || this.pgmAdDto.contentUrl.ko.trim() === "")  {
                    alert("이미지를 등록하세요.")
                    return
                }

                let success = () => {
                    this[SHOW_MODAL]({msg: '등록이 완료되었습니다.', okHandling: () => {this.$router.push({name: this.config.type + 'List'})}})
                }
                let fail = () => {
                    $showModalWithErrorMsg.bind(this)
                }

                if (this.$route.params.pgmAdId != null) {
                    let pgmAdDto = this.makePutPgmAdDto(this.pgmAdDto)
                    console.log('modify')
                    console.log(pgmAdDto)
                    playGameService.updateMainstream(this.pgmAdDto).then(success).catch(fail)
                } else {
                    playGameService.createMainstream(this.pgmAdDto).then(success).catch(fail)
                }
            },
            ...mapMutations('ui', [SHOW_MODAL])
        },
        computed: {
            ...mapGetters('preg', [
                'osOptionsForBootstrap'
            ])
        },
    }
</script>
<style>
    .vSelectWrapper {
        display: inline-block;
        width: 350px;
    }
    .vSelectWrapper .dropdown-toggle:after {
        display: none !important;
    }
</style>
